import {ILookupEntry} from 'shared/types/lookups';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';
import {IEtlAuditTableData, IEtlSubAuditArgs, IEtlSubAuditDto} from 'store/slices/etl-slice/model/types';

export const fetchEtlAuditData = async (
    data?: Record<string, string | number | undefined>,
) => performRequest<IEtlAuditTableData>({
    method: ERequestType.GET,
    url: '/etl-audit',
    params: data,
    urlConfig: {
        baseUrl: '',
        contextUrl: '/external-loading/private',
    },
});

export const fetchEtlSubAudit = ({loadId, organizationId}: IEtlSubAuditArgs) => performRequest<IEtlSubAuditDto[]>({
    method: ERequestType.POST,
    url: `/etl-sub-audit/${loadId}`,
    params: {orgId: organizationId},
    urlConfig: {
        baseUrl: '',
        contextUrl: '/external-loading/private',
    },
});

export const fetchEtlUploadScenario = async () => performRequest<ILookupEntry[]>({
    method: ERequestType.POST,
    url: 'valueLists/ETL_SCENARIO_CODE',
    urlConfig: {
        baseUrl: '',
        contextUrl: '/external-loading/private',
    },
});
